/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是 ClDrawMark 的实体定义

import {
    _getTxtWidth,
    _drawTxt
} from './cl.draw'
import {
    findNearTimeToIndex
} from './cl.chart.tools'
import {
    initCommonInfo
} from './cl.chart.init'

import {
    ASCIIMAPS
} from '../cl.chart.res'

import { getValue } from '../datas/cl.data'

// 创建时必须带入父类，后面的运算定位都会基于父节点进行；
// 这个类仅仅是画图, 因此需要把可以控制的rect传入进来
/**
 * Class representing ClDrawMark
 * @export
 * @class ClDrawMark
 */
export default class ClDrawMark {
    /**

     * Creates an instance of ClDrawMark.
     * @param {Object} father
     * @param {Object} rectMain
     */
    constructor(father, rectMain) {
        initCommonInfo(this, father)
        this.rectMain = rectMain
        this.offset = this.father.layout.offset
        this.father = father
        this.symbol = this.father.layout.symbol
    }
    /**
     * paint
     * @param {String} key
     * @memberof ClDrawMark
     */
    getShowTxt(mark) {
        // console.log(mark, ASCIIMAPS[mark]);
        if (mark === '0') {
            return undefined
        }
        if (this.info.drawMethod === 'strToMap') {
            return ASCIIMAPS[mark]
        }
        return undefined
    }
    onPaint(key) {
        this.dataLayer = this.father.father.dataLayer
        this.linkInfo = this.dataLayer.linkInfo
        this.axisYdata = this.father.axisYdata

        if (key !== undefined) this.hotKey = key
        this.data = this.father.father.getData(this.hotKey)

        for (let i = this.linkInfo.minIndex; i <= this.linkInfo.maxIndex; i++) {
            const mark = getValue(this.data, this.info.fieldY, i)
            let onemark = this.getShowTxt(mark)
            if (onemark === undefined) {
                continue
            }
            const len = _getTxtWidth(this.context, onemark, this.symbol.font, this.symbol.pixel)
            const offset = i - this.linkInfo.minIndex
            const xx = this.rectMain.left + offset * (this.linkInfo.unitX + this.linkInfo.spaceX) + Math.floor(this.linkInfo.unitX / 2)
            if (xx < this.rectMain.left) {
                continue
            }
            // 获取颜色
            let clr = this.color.button
            if (this.info.clrMethod !== undefined) {
                if (this.info.clrMethod == 'getBSClr') {
                    clr = mark === 'fbox' ? this.color.yellow : (mark === 'bid' ? this.color.red : this.color.green)
                }
            }
            else if (this.info.color !== undefined) {
                clr = this.color[this.info.color]
            }
            
            // 获取Y坐标
            let yy = this.rectMain.top + this.rectMain.height + this.offset.bottom / 2
            if (this.info.place !== undefined) {
                if (this.info.place.style == 'top') {
                    yy = this.rectMain.top - this.offset.top / 2
                }
                else if (this.info.place.style == 'field') {
                    const val = getValue(this.data, this.info.place.field, i)
                    yy = this.rectMain.top + Math.floor((this.axisYdata.max - val) * this.axisYdata.unitY)
                }
            }       
            
            _drawTxt(this.context, xx - Math.floor(len / 2), yy,
                onemark, this.symbol.font, this.symbol.pixel, clr, {
                    y: 'middle'
                })
        }
    }
}